<form [formGroup]="mainForm">
  <h1>{{ orgCampaignDetails.Description }}</h1>
  <h2>Billing Address</h2>
      <div class="p-grid p-fluid no-margin">
        <div class="col-md-12 col-sm-12 margin-top-10 checkbox">
          <p-checkbox
            formControlName="useMailing"
            binary="true"
            [value]="true"/>
          <label>Use Mailing Address</label>
        </div>
        @if(orgCampaignDetails && contextService.contextObject.tenantName) {
          <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
            <app-address-form-custom  [canTabWrite]="true" [showCounty]="false" [showZipPlus4]="false" [incomingAddressBilling]="incomingAddressBilling"
                                      [showCategory]="false" (outgoingAddress)="setAddress($event)" [disabled]="mainForm.get('useMailing').value === true"></app-address-form-custom>
          </div>
        }
        <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 checkbox">
          <p-checkbox
            formControlName="agree"
            [value]="true"
            [binary]="true" />
          <label>I agree<sup class="req">*</sup></label>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
          <div class="legal-agreement">
            <div [innerHTML]="orgCampaignDetails.RegistrationDisclaimer"></div>
          </div>
<!--         <textarea-->
<!--           rows="5"-->
<!--           cols="30"-->
<!--           pInputTextarea-->
<!--           [readonly]="true"-->
<!--           [(ngModel)]="legal" [ngModelOptions]="{standalone: true}" >-->
<!--          </textarea>-->
        </div>
        <div class="contribution margin-top-10">
          Contribution: ${{ campaignProfile.ContributionAmount }}
        </div>
        <div class="next-page-button">
          @if (!isSaving) {
            <p-button label="Submit" (click)="goToNextPage()" [disabled]="mainForm.invalid"/>
          }
          @if (isSaving) {
            <p-button  label="Submit" class="p-button-info export-excel p-mr-2" [className]="'inline-button'"
                    [disabled]="true">
              <i class="pi pi-spin pi-spinner save-spinner"></i>
            </p-button>
          }
        </div>
      </div>
</form>
